import { useEffect, useState } from 'react';
import { inferAddendumFromCountry, } from '../utils/privacyJurisdiction';
import { loadPrivacyGeoOnce, readPrivacyGeoCache } from '../utils/privacy-context';
function getBrowserRegionCountry() {
    if (typeof navigator === 'undefined')
        return null;
    const candidates = [...(navigator.languages || []), navigator.language].filter(Boolean);
    for (const tag of candidates) {
        const parts = tag.split(/[-_]/);
        if (parts.length < 2)
            continue;
        const region = parts[parts.length - 1].toUpperCase();
        if (region.length === 2 && /^[A-Z]{2}$/.test(region)) {
            return region;
        }
    }
    return null;
}
export function usePrivacyJurisdiction() {
    const cached = typeof window !== 'undefined' ? readPrivacyGeoCache() : null;
    const [ipCountryCode, setIpCountryCode] = useState(cached?.countryCode ?? null);
    const [consentFirstDefault, setConsentFirstDefault] = useState(cached?.consentFirstDefault ?? false);
    const [showDoNotSellLink, setShowDoNotSellLink] = useState(cached?.showDoNotSellLink ?? false);
    const [isLoading, setIsLoading] = useState(typeof window === 'undefined' ? false : !cached);
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        const syncFromCache = () => {
            const ctx = readPrivacyGeoCache();
            if (!ctx)
                return;
            setIpCountryCode(ctx.countryCode);
            setConsentFirstDefault(ctx.consentFirstDefault);
            setShowDoNotSellLink(ctx.showDoNotSellLink);
        };
        let cancelled = false;
        (async () => {
            await loadPrivacyGeoOnce();
            if (cancelled)
                return;
            syncFromCache();
            setIsLoading(false);
        })();
        window.addEventListener('mypace:privacy-geo-updated', syncFromCache);
        return () => {
            cancelled = true;
            window.removeEventListener('mypace:privacy-geo-updated', syncFromCache);
        };
    }, []);
    const browserCountryCode = typeof navigator !== 'undefined' ? getBrowserRegionCountry() : null;
    const effectiveCountryCode = ipCountryCode ?? browserCountryCode;
    let suggestedAddendum = 'uk_eu_gdpr';
    const inferred = inferAddendumFromCountry(effectiveCountryCode);
    if (inferred)
        suggestedAddendum = inferred;
    return {
        effectiveCountryCode,
        suggestedAddendum,
        ipCountryCode,
        browserCountryCode,
        consentFirstDefault,
        showDoNotSellLink,
        isLoading,
    };
}
